import { Component, OnInit } from '@angular/core';
import { ProjectCrmCompareData, Projects, StatusButtons } from "../../../_shared/interfaces";
import {
  AlertService,
  ContactsStoreService,
  CrmStoreService,
  IAlertType,
  ProjectsStoreService
} from "../../../_shared/services";
import { ActivatedRoute } from "@angular/router";
import { CurrencyPipe, DatePipe, NgForOf, NgIf } from "@angular/common";
import { ClrDropdownModule, ClrIconModule, ClrModalModule, ClrTabsModule } from "@clr/angular";
import { ClarityIcons, twoWayArrowsIcon, angleIcon, uploadIcon } from '@cds/core/icon';
import { StaffStoreService } from "../../../_shared/services";
import { ProjectDetailsDeliveryComponent } from "./project-details-delivery/project-details-delivery.component";
import { ProjectDetailsDocumentsComponent } from "./project-details-documents/project-details-documents.component";
import { ProjectDetailsPositionsComponent } from "./project-details-positions/project-details-positions.component";
import { ProjectDetailsRequestsComponent } from "./project-details-requests/project-details-requests.component";
import { ProjectDetailsOrderComponent } from "./project-details-order/project-details-order.component";
import { ProjectDetailsTransportComponent } from "./project-details-transport/project-details-transport.component";
import { ProjectDetailsOfferComponent } from "./project-details-offer/project-details-offer.component";
import { ProjectDetailsInvoicesComponent } from "./project-details-invoices/project-details-invoices.component";
import { UploadComponent } from "../../../core/upload/upload.component";
import { ProjectDetailsJobsComponent } from "./project-details-jobs/project-details-jobs.component";
import { ProjectDetailsStammdatenComponent } from "./project-details-stammdaten/project-details-stammdaten.component";
import { getTenantStorage } from '../../../_shared/utils/tenant-context';
import moment from 'moment';

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-project-details',
  standalone: true,
  imports: [
    NgIf,
    ClrIconModule,
    ClrDropdownModule,
    ClrTabsModule,
    ClrModalModule,
    CurrencyPipe,
    NgForOf,
    UploadComponent,
    ProjectDetailsDeliveryComponent,
    ProjectDetailsDocumentsComponent,
    ProjectDetailsPositionsComponent,
    ProjectDetailsRequestsComponent,
    ProjectDetailsOrderComponent,
    ProjectDetailsTransportComponent,
    ProjectDetailsOfferComponent,
    ProjectDetailsInvoicesComponent,
    ProjectDetailsJobsComponent,
    ProjectDetailsStammdatenComponent,
    DatePipe
  ],
  templateUrl: './project-details.component.html',
  styleUrl: './project-details.component.sass'
})
export class ProjectDetailsComponent implements OnInit {
  project: Projects | null = null;
  projectid: string = '';
  companyid: number = 0;
  statusLabel = 'label-light-blue';
  statusText = '';
  staffFirstName: string = '';
  staffLastName: string = '';
  devMode: boolean;
  crmMode: boolean;
  public showFileUpload = false;
  public loading: boolean = true;
  crmCompare: ProjectCrmCompareData | null = null;
  crmCompareLoading = false;
  crmSyncRunning = false;

  statusButtons: StatusButtons[] = [
    { state: '', display: '---', label: 'label-danger', icon: 'check-circle', locked: true},
    { state: 'open', display: 'Offen', label: 'label-light-blue', icon: 'info-circle', locked: false},
    { state: 'running', display: 'In Arbeit', label: 'label-warning', icon: 'info-circle', locked: false},
    { state: 'requested', display: 'Projekt', label: 'label-light-blue', icon: 'info-circle', locked: false},
    { state: 'confirmed', display: 'Auftrag', label: 'label-info', icon: 'info-circle', locked: true},
    { state: 'lost', display: 'Verloren', label: 'label-danger', icon: 'check-circle', locked: false},
    { state: 'invoiced', display: 'Berechnet', label: 'label-green', icon: 'check-circle', locked: true},
    { state: 'finished', display: 'Erledigt', label: 'label-success', icon: 'info-circle', locked: true}
  ];

  constructor(
    private pss: ProjectsStoreService,
    private contss: ContactsStoreService,
    private crmss: CrmStoreService,
    private alertDispatcher: AlertService,
    private stss: StaffStoreService,
    private route: ActivatedRoute,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon, angleIcon, uploadIcon);
    this.devMode = env.stages.dev;
    this.crmMode = env.externalCrm;
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.projectid = params.get('prid') ?? '';
    this.companyid = parseInt(params?.get('cid') ?? '0', 10);
    this.loadSingleProject(this.companyid, this.projectid);
  }

  // Anpassung Farbe und Text des Statusbuttons...
  findButtonStatus(projectstatus: string, buttons: StatusButtons[]) {
    return buttons.findIndex(el => el.state === projectstatus)
  };

  buttonStatus(status: string){
    const statusline = this.findButtonStatus(status, this.statusButtons);
    const idx = statusline >= 0 ? statusline : 0;
    this.statusLabel = this.statusButtons[idx].label;
    this.statusText = this.statusButtons[idx].display;
  }

  showFileUploader() {
    this.showFileUpload = true;
  }

  loadSingleProject(company: number, project: string): void {
    this.pss.filterProjectsPPS(company, project, 0, 'all').subscribe({
      next: data1 => {
        if (!data1 || !data1.object || data1.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Projektdaten gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
            return;
        }

        this.project = data1.object[0];

        // Status gestalten
        const statusline = this.findButtonStatus(this.project.status, this.statusButtons);
        this.statusLabel = this.statusButtons[statusline]?.label ?? 'Unbekannt';
        this.statusText = this.statusButtons[statusline]?.display ?? 'Unbekannter Status';

        // Staff-Status nur setzen, wenn employee_phm vorhanden ist
        if (this.project.employee_phm) {
            this.staffStatus(this.project.employee_phm.toString());
        } else {
            this.alertDispatcher.alertConfig.message += 'Der verantwortliche Mitarbeiter wurde nicht ermittelt!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
        }

        // NDA-Prüfung
        this.checkNda(this.project.cid);

        if (this.crmMode) {
          this.loadCrmCompare(this.crmProjectRef);
        }
      },

      error: err => {
        this.alertDispatcher.alertConfig.message += 'Error: Projekt konnte nicht geladen werden!';
        this.alertDispatcher.alertConfig.clrAlertType = IAlertType.DANGER;
      },

      complete: () => {
        this.loading = false;
        if (this.devMode) console.log("Projekt erfolgreich geladen und verarbeitet.");
      }
    });
  }

  get crmProjectRef(): string {
    const parsed = parseInt(this.projectid, 10);
    const projectNumber = Number.isFinite(parsed) ? parsed.toString().padStart(4, '0') : this.projectid;
    return `${this.companyid}.${projectNumber}`;
  }

  get displayProjectId(): string {
    const parsed = parseInt(this.projectid, 10);
    return Number.isFinite(parsed) ? parsed.toString().padStart(4, '0') : this.projectid;
  }

  loadCrmCompare(projectRef: string) {
    if (!projectRef) {
      this.crmCompare = null;
      return;
    }

    const sessionId = this.crmss.getCrmToken() ?? '';
    this.crmCompareLoading = true;
    this.pss.getCrmCompare(projectRef, sessionId).subscribe({
      next: (res) => {
        this.crmCompare = res?.data ?? null;
      },
      error: () => {
        this.crmCompare = null;
      },
      complete: () => {
        this.crmCompareLoading = false;
      }
    });
  }

  get crmCompareLabel(): string {
    if (!this.crmMode) return 'CRM aus';
    if (this.crmCompareLoading) return 'Pruefung laeuft';
    if (!this.crmCompare) return 'Nicht verfuegbar';
    return this.crmCompare.in_sync ? 'Synchron' : 'Abweichung';
  }

  get crmCompareClass(): string {
    if (!this.crmMode) return 'label';
    if (this.crmCompareLoading) return 'label label-info';
    if (!this.crmCompare) return 'label label-warning';
    return this.crmCompare.in_sync ? 'label label-success' : 'label label-danger';
  }

  getDiffFieldLabel(field: string): string {
    const labels: Record<string, string> = {
      project_key: 'Projekt-Key',
      name: 'Projektname',
      start_date: 'Start',
      end_date: 'Ende',
      leader: 'Leiter'
    };
    return labels[field] ?? field;
  }

  syncCrmNow() {
    if (!this.project || this.crmSyncRunning) return;

    const projectRef = this.crmProjectRef;
    if (!projectRef) {
      this.alertDispatcher.show({
        message: 'CRM-Sync nicht möglich: kein Projekt-Key verfügbar.',
        clrAlertType: IAlertType.WARNING
      }, 4000);
      return;
    }

    const sessionId = this.crmss.getCrmToken() ?? '';
    const staffId = parseInt(getTenantStorage('staff_id') ?? getTenantStorage('user_id') ?? '0', 10);

    if (!sessionId || !staffId) {
      this.alertDispatcher.show({
        message: 'CRM-Sync nicht möglich: CRM-Token oder Staff-ID fehlt.',
        clrAlertType: IAlertType.WARNING
      }, 4000);
      return;
    }

    this.crmSyncRunning = true;
    this.pss.syncCrmProject(projectRef, {
      session_id: sessionId,
      staff_id: staffId
    }).subscribe({
      next: (res) => {
        this.crmCompare = res?.data ?? this.crmCompare;
        this.alertDispatcher.show({
          message: this.crmCompare?.in_sync ? 'CRM-Sync erfolgreich.' : 'CRM-Sync mit Abweichungen abgeschlossen.',
          clrAlertType: this.crmCompare?.in_sync ? IAlertType.SUCCESS : IAlertType.WARNING
        }, 3000);
      },
      error: () => {
        this.alertDispatcher.show({
          message: 'CRM-Sync fehlgeschlagen.',
          clrAlertType: IAlertType.DANGER
        }, 4000);
      },
      complete: () => {
        this.crmSyncRunning = false;
      }
    });
  }

  formatProjectDate(value: string | null | undefined): string {
    if (!value) {
      return '---';
    }

    const parsed = moment(value, ['DD.MM.YYYY', 'YYYY-MM-DD'], true);
    return parsed.isValid() ? parsed.format('DD.MM.YYYY') : value;
  }

  async updateRequestStatusWithIgnore(projectID: string): Promise<any> {
    /*this.reqss.updateRequestStatus(projectID, 0, "ignored").subscribe(change => {
      if (!change) {
        return;
      }
    })*/
    return;
  }

  checkNda(contactID: number){
    let nda: boolean = true;
    this.contss.getSingleCompany(contactID)
      .subscribe({
        next: company => {
          if (!company || !company.object || company.object.length === 0) {
            this.alertDispatcher.alertConfig.message = 'Keine Firma gefunden!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
            return;
          }
          if (company.object[0].nda) nda = company.object[0].nda
        },
        complete: () => {
          switch (nda){
            case true:
              this.alertDispatcher.alertConfig.message = 'Bitte beachten: Für diese Firma liegt ein NDA vor!';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
              break;
            default:
              this.alertDispatcher.alertConfig.message = 'All engines running! :) ';
              this.alertDispatcher.alertConfig.clrAlertType = IAlertType.SUCCESS;
              break;
          }
        }
      })
  }

  staffStatus(staffID: string){
    this.stss.getStaffById(parseInt(staffID))
      .subscribe({
        next: staff=> {
          if (!staff || !staff.object || staff.object.length === 0) {
            this.alertDispatcher.alertConfig.message = 'Keinen Mitarbeiter gefunden!';
            this.alertDispatcher.alertConfig.clrAlertType = IAlertType.WARNING;
            return;
          }
          this.staffFirstName = staff.object[0].firstname;
          this.staffLastName = staff.object[0].lastname;
        },
        complete: () => {
        },
        error: () => {
          return
        }
      });
  }

  changeProjectStatus(companyID: number, projectID: string, status: number){
    if (confirm('Wollen Sie den Status dieses Projekts wirklich auf "' + this.statusButtons[status].display + '" setzen?')) {
      this.pss.updateProjectStatus(companyID, projectID, this.statusButtons[status].state)
        .subscribe({
          next: () => {
            this.updateRequestStatusWithIgnore(companyID + "." + projectID);
            if (this.devMode) console.log('Hier würden Requests unter bestimmten Bedingungen auf "ignored" gesetzt werden.')
            //}
            //}
          },
          complete: () => {
            this.loadSingleProject(companyID, projectID);
          }
        });
    }
  }

  closeModal(state: boolean) {
    this.showFileUpload = state;
  }
}
